import React, { FC } from 'react';
import { ContentBanner } from '@modernhealth/vital-components';

import { ContentCardProps } from './ContentCard';
import { mapContentLinkToContentBannerProps } from '../helpers/contentLinkNodeToContentBanner';
import { SectionType } from '../helpers/getTrackClickCallback';
import { useAnalytics } from '@modernhealth/web-analytics';

interface BannerContentCardProps extends ContentCardProps {
    section?: SectionType;
}

export const BannerContentCard: FC<BannerContentCardProps> = ({ links, section }) => {
    const { trackClick } = useAnalytics();

    const mappedLink = mapContentLinkToContentBannerProps({
        link: links[0],
        tracking: {
            props: { page_section: section?.title, page_section_uuid: section?.id },
            trackClick,
        },
    });
    if (!mappedLink) {
        return null;
    }

    return <ContentBanner {...mappedLink} />;
};
